module.exports = __webpack_public_path__ + "img/icon_pin.07a45c28.svg";